/* template */
<template minapp="mpx" xlang="wxml"><div class="bubble-button-container" v-if="(bubbleText)"><div class="before-button bubble-button">{{ bubbleText }}</div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"md2aa2f48"}'>
  .bubble-button-container
    position relative
    .bubble-button
      width 100%
      height 100%
      padding 2px 9px
      box-sizing border-box
      border-radius 11px 11px 0 11px
      border 1px solid #ffffff

    .before-button
      position relative
      z-index 2
      background linear-gradient(179deg, #FFECAB 3%, #FFF6DD 151%)
      display flex
      justify-content center
      align-items center
      font-family PingFang SC
      font-size 11px
      font-weight 500
      color #FF5900
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "md2aa2f48"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexd2aa2f48%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexd2aa2f48%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["md2aa2f48"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexd2aa2f48/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
